var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.447368, 0.552632)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7165,9.77625 L3.414,10.83675 L4.4745,5.5335 L8.508,1.5 L1.5,1.5 C0.67275,1.5 0,2.1735 0,3 L0,13.5 C0,14.32725 0.67275,15 1.5,15 L12,15 C12.82725,15 13.5,14.32725 13.5,13.5 L13.5,4.992 L8.7165,9.77625 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.856 6.27375 7.977 8.394 5.32575 8.92425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8105,2.5605 C14.39625,1.97475 14.39625,1.02525 13.8105,0.4395 C13.22475,-0.14625 12.27525,-0.14625 11.6895,0.4395 L6.9165,5.2125 L9.03825,7.33425 L13.8105,2.5605 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.6ee19dcae8114537cebae0d11d87d0f4.svg";
export { ForwardRef as ReactComponent };